import React, { Component } from 'react';
import save from '../../resources/images/estrategas/tools/save.png';
import * as Request from '../../service/data-info-chart/requestsUtil';
import Loader from 'react-loader';


class Save extends Component {

  constructor(props) {
    super(props);
    this.callbackFromParent = this.callbackFromParent.bind(this);
    this.state={ loaded: true }
  }

  callbackFromParent(){
    this.props.callbackFromParent(Math.random());
  }

  sendFile = event => {
    this.setState({ loaded: false });
    const file = event.target.files[0];
    const fd = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };

    if (file !== undefined) {
      fd.append('file', file);
      fd.append('date', this.props.date);
      if (this.props.bu !== null && this.props.bu !== undefined) {
        fd.append('id', this.props.bu)
      }
      Request.postFetch2(this.props.url, fd, config)
        .then(resp => {
          this.setState({ loaded: true }, this.props.callback(Math.random()));
        });
    }
  };

  render() {

    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';

    return (
      <div className={classUser}>
        <Loader loaded={this.state.loaded}/>
        <form action={''} method="post" encType="multipart/form-data">
          <input style={{ display: 'none' }} type="file" name="file"
                 id="exampleFile" onChange={this.sendFile.bind(this)}
                 ref={fileInput => this.fileInput = fileInput}/>
          <img src={save} title="Guardar" alt=" " onClick={() => this.fileInput.click()}/>
        </form>
      </div>

    )
      ;
  }
}

export default Save;



// WEBPACK FOOTER //
// ./src/components/buttons/save.js